module.exports = __webpack_public_path__ + "static/media/BarChart.4fb4426b.svg";